import React, { useEffect, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Download } from "react-bootstrap-icons";
import { usePaymentPlansQuery } from "../../../graphql/payment.hooks";
import {
  isPaymentError,
  isPaymentLoading,
  selectedCurrency,
} from "../../../graphql/state";
import { useReactiveVar } from "@apollo/client";
import { GetStatus } from "../paymentStatus";

export default function Invoice() {
  const { t } = useTranslation();
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const currentCurrency = useReactiveVar(selectedCurrency);
  const paymentLoading = useReactiveVar(isPaymentLoading);

  const { data, loading, error } = usePaymentPlansQuery({
    variables: { locale: "en", currency: currentCurrency },
  });

  useEffect(() => {
    if (!error) return;
    isPaymentError(true);
  }, [error]);

  useEffect(() => {
    if (!data?.paymentPlans?.paymentOrders) return;
    const updatedInvoices = data?.paymentPlans.paymentOrders.filter(
      ({ status }) => status
    );
    const isLoadingOrder = data?.paymentPlans.paymentOrders.filter(
      ({ status }) => status === 4
    );

    if (isLoadingOrder[0]) {
      isPaymentLoading(true);
    } else {
      setTimeout(() => isPaymentLoading(false), 3000);
    }
    setFilteredInvoices(updatedInvoices);
  }, [data?.paymentPlans?.paymentOrders]);

  if (loading) {
    return (
      <div className="text-center">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data?.paymentPlans?.paymentOrders?.length || !filteredInvoices?.length) {
    return null;
  }

  return (
    <div className="bg-white rounded p-4">
      <div className="mb-4 fw-bold fs-4">{t("payment.Payment")}</div>
      <div className="overflow-x-auto">
        <Table className="table table-responsive table-borderless">
          <thead>
            <tr>
              <th>{t("payment.Amount")}</th>
              <th>{t("payment.Subscription")}</th>
              <th>{t("payment.Date")}</th>
              <th>{t("payment.Status")}</th>
              <th>{t("payment.Invoice")}</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.map((item) => (
              <tr key={item.id}>
                <td className="fw-bold">
                  {
                    data?.paymentPlans.currencies.find(
                      ({ currencyName }) => item.currency === currencyName
                    )?.currencySymbol
                  }
                  {item.amountMinusDiscount}
                </td>
                <td>
                  {item.planId === 20
                    ? t("payment.Premium (Monthly)")
                    : t("payment.Premium (Annually)")}
                </td>
                <td>{new Date(item.createdAt).toLocaleDateString("uk-UK")}</td>
                <td>
                  <GetStatus status={item?.status} />
                </td>
                <td className="text-center">
                  <Button
                    disabled={paymentLoading}
                    as="a"
                    href={`${process.env.REACT_APP_ME_PAGE_URL}/invoice/download-invoice?orderId=${item.id}`}
                    download="invoice.pdf"
                    variant="link"
                    className={`${paymentLoading ? "text-gray" : "text-dark"}`}
                  >
                    <Download />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
